<div [id]="CONTAINER_ID" class="skyvector-chart__chart"></div>
